import type { AppAbility } from '@/plugins/casl/ability'

export const useAbility = () => {
  const { $ability } = useNuxtApp()
  return $ability as typeof AppAbility
}
